import { render, staticRenderFns } from "./procure.vue?vue&type=template&id=468e5d08&scoped=true&"
import script from "./procure.vue?vue&type=script&lang=js&"
export * from "./procure.vue?vue&type=script&lang=js&"
import style0 from "./procure.vue?vue&type=style&index=0&id=468e5d08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468e5d08",
  null
  
)

export default component.exports